// Screen Wake Lock helper. Keeps the screen on while held.
let sentinel = null;
let keepAlive = false;

const acquire = async () => {
  if (!("wakeLock" in navigator)) return null;
  try {
    const s = await navigator.wakeLock.request("screen");
    s.addEventListener?.("release", () => {
      sentinel = null;
      // Re-acquire if we still want it (page becomes visible again)
      if (keepAlive && document.visibilityState === "visible") {
        acquire();
      }
    });
    sentinel = s;
    return s;
  } catch {
    return null;
  }
};

export const startWakeLock = () => {
  keepAlive = true;
  if (!sentinel) acquire();
  // On visibility change, re-acquire
  document.addEventListener("visibilitychange", onVisibility);
};

export const stopWakeLock = () => {
  keepAlive = false;
  document.removeEventListener("visibilitychange", onVisibility);
  try {
    sentinel?.release?.();
  } catch {}
  sentinel = null;
};

function onVisibility() {
  if (document.visibilityState === "visible" && keepAlive && !sentinel) {
    acquire();
  }
}
